import { useNavigate } from "react-router-dom";
import { Layout } from "antd";
import { GithubOutlined } from "@ant-design/icons";

import { signUpPath } from "../../helpers/paths";
import cronosLogo from "../../images/cronos-logo-blue.svg";
import { GITHUB_CLIENT_ID, GITHUB_OAUTH_LOGIN_BASEURL } from "../../config/StaticConfig";

export function SignIn() {
  const navigate = useNavigate();

  return (
    <Layout className="auth-content-wrapper">
      <div className="auth-content">
        <div className="logo">
          <img src={cronosLogo} alt="cronos" />
        </div>

        <a
          style={{ marginBottom: 20 }}
          className="github-button"
          href={`${GITHUB_OAUTH_LOGIN_BASEURL}?client_id=${GITHUB_CLIENT_ID}&scope=user:email`}
        >
          <GithubOutlined />
          Sign in with Github
        </a>
        <a
          style={{ backgroundColor: "#ffffff00", color: "#000" }}
          className="github-button"
          onClick={() => navigate(signUpPath())}
          href={"#/"}
        >
          Don't have account? Sign up here
        </a>
      </div>
      <div className="auth-footer">Powered by CronosLabs &copy; 2022</div>
    </Layout>
  );
}
